import { createContext } from "react"

const PermissionContext = createContext();

export { PermissionContext }